"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCategory = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var FileCategory;
(function (FileCategory) {
    FileCategory["Archive"] = "Archive";
    FileCategory["Audio"] = "Audio";
    FileCategory["Bioinformatics"] = "Bioinformatics";
    FileCategory["BusinessIntelligence"] = "BusinessIntelligence";
    FileCategory["CertificatesAndKeys"] = "CertificatesAndKeys";
    FileCategory["Chemical"] = "Chemical";
    FileCategory["Database"] = "Database";
    FileCategory["Diagram"] = "Diagram";
    FileCategory["Document"] = "Document";
    FileCategory["Electrical"] = "Electrical";
    FileCategory["Email"] = "Email";
    FileCategory["Encrypted"] = "Encrypted";
    FileCategory["Executable"] = "Executable";
    FileCategory["GraphicDesign"] = "GraphicDesign";
    FileCategory["Image"] = "Image";
    FileCategory["Mechanical"] = "Mechanical";
    FileCategory["MedicalImaging"] = "MedicalImaging";
    FileCategory["MicrosoftProprietaryData"] = "MicrosoftProprietaryData";
    FileCategory["Pdf"] = "Pdf";
    FileCategory["Presentation"] = "Presentation";
    FileCategory["ResearchAndTechnicalDocuments"] = "ResearchAndTechnicalDocuments";
    FileCategory["Script"] = "Script";
    FileCategory["SourceCode"] = "SourceCode";
    FileCategory["Spreadsheet"] = "Spreadsheet";
    FileCategory["StructuredData"] = "StructuredData";
    FileCategory["Topography"] = "Topography";
    FileCategory["Uncategorized"] = "Uncategorized";
    FileCategory["Video"] = "Video";
    FileCategory["VirtualDiskImage"] = "VirtualDiskImage";
    FileCategory["WebDevelopmentAndDesign"] = "WebDevelopmentAndDesign";
})(FileCategory = exports.FileCategory || (exports.FileCategory = {}));
